import { component } from "picoapp";

export default component(async (node) => {
  const [{ default: KeenSlider }] = await Promise.all(
    import("keen-slider"),
    import("keen-slider/keen-slider.min.css")
  );

  const sliderElement = node.querySelector("[data-keen-slider]");
  const productLink = node.querySelector("[data-product-link]");
  const slider = new KeenSlider(sliderElement, {
    drag: false,
    slideChanged: (s) => {
      s.slides.forEach((slide, index) => {
        slide.style.opacity = s.track.details.slides[index].portion;
      });
    },
    detailsChanged: (s) => {
      const width = s.size;
      s.slides.forEach((slide, index) => {
        slide.style.transform = `translate3d(-${width * index}px, 0px, 0px)`;
        slide.style.minWidth = width + "px";
        slide.style.maxWidth = width + "px";
        slide.style.opacity = s.track.details.slides[index].portion;
      });
    },
    created(s) {
      s.container.classList.remove("hide-init");
    },
  });

  const options = node.querySelectorAll('input[type="radio"]');
  options.forEach((option) => {
    option.addEventListener("click", function () {
      const index = option.dataset.index;
      slider.moveToIdx(parseInt(index));
      if (productLink) {
        const url = new URL(productLink.href);
        url.searchParams.set("variant", option.dataset.vid);
        productLink.href = url.href;
      }
    });
  });

  window.addEventListener("option-change:color", (event) => {
    const { value, checked, unchecked } = event.detail;
    if (value) {
      const optionElement = node.querySelector(`input[value="${checked}"]`);
      if (optionElement) optionElement.click();
    } else {
      const optionElement = node.querySelector(`input[value="${unchecked}"]`);
      if (optionElement) optionElement.click();
    }
  });
});
